<div>
  <mat-card-header class="container p-b-16">
    <header class="site-header  py-1 border-bottom">
      <nav class="d-flex flex-column flex-md-row justify-content-between">


        <a class="py-2" href="https://andica.com/images/logo_andica.gif" aria-label="Product">
          <img class="float-md-start mb-0 d-block mx-auto radius-0" alt="Andica Limited" src="https://andica.com/images/logo_andica.gif" />
        </a>

      </nav>
    </header>
  </mat-card-header>

  <mat-card-content class="container p-x-36 main-content">
    <mat-card-header class="header-bg-dark" style="padding: 60px 0px !important; border-radius: 6px;">
      <div class="container ">
        <mat-card-title>
          <h1 class="text-white text-center" style="font-weight: 200;">Forgot your password?</h1>
        </mat-card-title>
      </div>
    </mat-card-header>
    <mat-card-content class="p-x-0 p-b-0">
      <mat-card-content class="p-x-0" style="padding-top: 0px;">
        <div class="col-12">
          <div class="row bS mobile p-6">
            <div class="col-lg-6 forgot-border-right bR-0 p-y-20">
              <div class="bg-notecard container-fluid cust-password">
                <p class="text-center f-s-14">
                  Enter your registered email address and we will send you a link to reset your password.
                </p>
              </div>
            </div>
            <div class="col-lg-6 p-y-30 m-t-10">
              <div class="m-y-8">
                <div class="forgot-email">
                  <form [formGroup]="EmailForm">
                    <span class="cust-prefix">Email</span>
                    <mat-form-field appearance="outline" color="primary">
                      <input matInput type="text" #emailInput placeholder="Enter Email" formControlName="EmailId" appTrimSpace maxlength="100" />
                      @if(EmailForm.get('EmailId')?.touched && EmailForm.get('EmailId')?.hasError('required')){
                      <mat-error>Email is required</mat-error>
                      } @else if(EmailForm.get('EmailId')?.touched && EmailForm.get('EmailId')?.hasError('pattern')){
                      <mat-error>Enter valid Email</mat-error>
                      }
                    </mat-form-field>
                  </form>
                </div>
              </div>
              <div class="m-y-8">
                <button mat-flat-button color="primary" class="px-3 cBtn" (click)="Send()" [disabled]="_disableSend">
                  Send
                </button>
                <button mat-flat-button class="bg-white p-x-12 mat-button-secondary text-secondary ml-10 b-1" (click)="Clear()">
                  Clear
                </button>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card-content>

  </mat-card-content>
  <footer style="position: fixed; width: 100%; bottom: 0;">
    <mat-card class="p-10 f-s-12 footer boxShadow">
      <div class="row p-10 text-black-25 text-center">
        <div class="col-12 col-md-6 col-xxl-6">
          <div class="float-start text-left fw-bold text-dark">
            Copyright © <a href="https://andica.com/" target="_blank" style="color: #ff6600; font-weight: bold; text-decoration: none !important"> 2004-{{nextyear}} Andica Limited.</a> All rights reserved.
          </div>
        </div>
        <div class="col-12 col-md-6 col-xxl-6">
          <div class="footer-left text-right text-md-end">
            <a href="https://www.andica.com/legal-software-licence-agreement.html" target="_blank" class="f-w-500" style="text-decoration: none; color: #346b88;">Licence Agreement</a> <span class="m-x-5 " style="font-size:18px !important">&middot;</span>
            <a href="https://www.andica.com/legal.html" target="_blank" class="f-w-500" style="text-decoration: none; color: #346b88;">Legal Terms</a>
          </div>
        </div>
      </div>
    </mat-card>
  </footer>
</div>

@if (_disableSend)
{
<div class="spinner-overlay">
  <mat-spinner class="spinner-cust"></mat-spinner>
</div>
}
